import React from 'react';
import { IconProps } from './types';

const CloseIcon = ({ className }: IconProps): React.ReactElement => (
  <svg
    className={`bundle-close-icon ${className}`}
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.432 4.84L4.84 6.433 10.409 12l-5.568 5.569 1.59 1.59L12 13.592l5.569 5.569 1.59-1.591L13.592 12l5.569-5.568-1.591-1.591L12 10.409 6.432 4.841z"
    />
  </svg>
);

export default CloseIcon;
